<div class="post-login-2">
    <div class="post-login-2-col-1 h-100">
        <left-panel activeTab="3"></left-panel>
    </div>
    <div class="post-login-2-col-2 has-banner p-0 h-100 overflow-y-hidden">
   <img src="~/../assets/images/left-banner.jpg" style="height: 100%; min-width: 100%;" alt="">
    </div>
    <div class="post-login-2-col-3 bg-base-100 ">
     <grid-row class="justify-content-center h-100">
        <grid-col col="10" mobile="12">
        <grid-row class="justify-content-between align-item-center">
            <grid-col col="auto">
                <grid-row class="col-space-min align-item-center">
                    <grid-col col="auto">
                        <div class="link" (click)="back()">
                            <ng-icon iconClass="icon-arrow-left-black" width="22" height="22"></ng-icon>
                        </div>
                    </grid-col>
                    <grid-col col="auto">
                        <div class="font-500 font-size-20px letter-spacing-1 color-base-1700"  *ngIf="this.serviceType === 'Conventional'">
                            {{'LoanStatement'|translate}}
                        </div>
                        <div class="font-500 font-size-20px letter-spacing-1 color-base-1700"  *ngIf="this.serviceType === 'Islamic'">
                            {{'FinanceStatement'|translate}}
                        </div>
                    </grid-col>
                </grid-row>
            </grid-col>
            <grid-col col="auto">
                <grid-row class="justify-content-between col-space-min">
                    <grid-col col="3">
                        <button class="btn-dft" (click)="this.showModal(1)">
                        {{"SendToEmail" | translate}}
                        </button>
                    </grid-col>
                    <!-- <grid-col col="3">
                   <div class="br-12 p-16 box-shadow-5 bg-base-100 link" (click)="DownloadStatement()">
                    <!-- <ng-icon iconClass="icon-download" width="24" height="24"></ng-icon> 
                    <ng-icon iconClass="icon-download-new" width="24" height="24"></ng-icon>
                   </div>
                    </grid-col> -->
                   </grid-row>
            </grid-col>
        </grid-row>
        <grid-row class="justify-content-between">
            <!-- <grid-col col="auto">
                <div class="font-400 font-size-14px line-h-20 color-base-1200 letter-spacing-1">
                    {{"PAYMENTHISTORY" | translate }}
                </div>
            </grid-col> -->
            <!-- <grid-col col="auto">
                <div class="form-group">
                    <drop-down-list borderRadius="br-100" dropDownImage="false" dropDownSearch="false"
                        [selectedValue]="this.selectedTrasactions" [dropDownData]="this.Trasactionslist"
                        (itemselected)="onTrasactionsChange($event)">
                        {{this.selectedTrasactions}}
                    </drop-down-list>
                </div>
            </grid-col> -->
        </grid-row>
        <div *ngIf="this.ViewStatementList">
            <div *ngFor="let items of ViewStatementList">
                <div class="font-400 font-size-14px color-base-1500 mb-5">
                    {{ items?.label }}
                </div>
                <div class="bg-base-100 box-shadow border border-color-900 br-12 mb-15 pl-15 pr-15">
                    <grid-row class="justify-content-between pt-10 pb-10" *ngFor="let item of items?.cardTransactions">
                        <grid-col col="auto">
                            <div class="font-400 font-size-12px line-h-20 color-base-1500">
                                {{item?.transactionDescription}}
                            </div>
                            <div class="font-400 font-size-12px line-h-12 color-base-1800 text-align-left"
                                *ngIf=" item?.transactionDate">
                                {{item?.transactionDate}}
                            </div>
                        </grid-col>
                        <grid-col col="auto">
                            <div class="font-600 font-size-14px line-h-20 color-Black" *ngIf="item?.debitCreditIndicator=='D'">
                                - {{item?.transactionCurrency}} {{item?.transactionAmount |amountFormatter}}
                            </div>
                            <div class="font-600 font-size-14px line-h-20 color-success"
                                *ngIf="item?.debitCreditIndicator=='C'">
                                {{item?.transactionCurrency}} {{item?.transactionAmount |amountFormatter}}
                            </div>
                            <!-- <div class="font-400 font-size-12px line-h-12 color-base-1800 mt-7 text-align-right">
                                GBP 140.71
                            </div> -->
                        </grid-col>
                    </grid-row>
                </div>
            </div>
        </div>
        </grid-col>
     </grid-row>
    </div>
</div>



<!-- Send to email Modal -->
<modal modalID="1" [events]="modalObservable.asObservable()" [backdropDismiss]="true" modalDoneButtonText="CONFIRM" (doneButton)="SendStatementToEmail()">
    <div>
        <div class="font-400 font-size-20px line-h-28 color-base-1300 mt-10 text-align-center">
            {{"PleaseEnterOrConfirmYourEmailAddress"| translate}}
        </div>
        <div class="form-group mt-50">
            <label class="no-mark">
              {{ "EmailAddress" | translate }}
            </label>
            <input type="email" placeholder="Please enter" [(ngModel)]="this.EmailIds">
          </div>
    </div>
</modal>